import { render } from "./TheInfoMenu.vue?vue&type=template&id=f6ca1f08&scoped=true"
import script from "./TheInfoMenu.vue?vue&type=script&lang=js"
export * from "./TheInfoMenu.vue?vue&type=script&lang=js"

import "./TheInfoMenu.vue?vue&type=style&index=0&id=f6ca1f08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ca1f08"]])

export default __exports__